// What a re-invite takes away, said before it is sent. The server asks
// (409 already_has_access) for anyone who has joined: a new invite takes
// their access away until they open the new email, and switches off the
// alerts the owner sends an editor (inviteTankShare sets alert_editor =
// false). A viewer never gets alerts, so they are not offered back.
export function reinviteWarning({ email, tankName, role, alerted, inviteRole }) {
  const now = role === 'editor' ? 'an editor' : 'a viewer';
  const next = inviteRole === 'editor' ? 'an editor' : 'a viewer';
  let body = `They are on ${tankName} as ${now}. A new invite takes their access away until they open the new email, then they join as ${next}.`;
  if (alerted) {
    body +=
      inviteRole === 'editor'
        ? " The tank's alerts you send them stop too; switch them on again once they join."
        : " The tank's alerts you send them stop too: viewers get no alerts.";
  }
  return { title: `${email} already has access`, body, confirmLabel: 'Send a new invite' };
}
